import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { UserBanksService } from "src/app/api/user-banks.service";
import { BankDetails } from "src/app/models/bank-details";
import { FileInput } from "src/app/models/support";

@Component({
    selector: "bank-ticket",
    templateUrl: "./bank-ticket.component.html",
    styleUrls: ["./bank-ticket.component.scss"],
    standalone: false
})
export class BankTicketComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;
  @Input() category: string;

  constructor(private userBanksService: UserBanksService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }

  ngOnInit() {
  }

  initiateForm() {
    this.form.addControl(
      "iban",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "bankName",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "accountHolderName",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "branchName",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "bankAddress",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "accountNumber",
      new FormControl("", [Validators.required, Validators.pattern(/^\d*$/)])
    );
    this.form.addControl(
      "swiftCode",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "personalPhoto",
      new FormControl("", [Validators.required])
    );
    this.form.addControl("message", new FormControl(""));
  }
  onFileSelect(file: FileInput, name: string) {
    this.form.get(name).setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove(name: string) {
    this.form.get(name).reset();
  }

  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  get iban() {
    return this.form.get("iban");
  }
  get bankName() {
    return this.form.get("bankName");
  }
  get accountHolderName() {
    return this.form.get("accountHolderName");
  }
  get branchName() {
    return this.form.get("branchName");
  }
  get bankAddress() {
    return this.form.get("bankAddress");
  }
  get accountNumber() {
    return this.form.get("accountNumber");
  }
  get swiftCode() {
    return this.form.get("swiftCode");
  }
  get personalPhoto() {
    return this.form.get("personalPhoto");
  }
}
